import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent, CustomValidators, FrontendDisplayHtmlType, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { AuthenticationService, ResetPasswordModel } from 'src/app/services/api-services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {
    resetPasswordForm: FormGroup;
    public type: FrontendDisplayHtmlType = FrontendDisplayHtmlType.ResetPasswordInfo;
    private token: string;
    private email: string;

    constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, private router: Router, private translatedToastrService: TranslatedToastrService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public ngOnInit(): void {
        this.resetPasswordForm = new FormGroup({
            password: new FormControl('', [Validators.required]),
            confirmPassword: new FormControl('', [Validators.required]),
        });

        this.resetPasswordForm.addValidators([CustomValidators.matchValidator('password', 'confirmPassword', 'password_does_not_match')]);

        this.token = this.route.snapshot.queryParams['token'];
        this.email = this.route.snapshot.queryParams['email'];
    }

    public validateControl = (controlName: string) => {
        return this.resetPasswordForm.get(controlName).invalid && this.resetPasswordForm.get(controlName).touched;
    };
    public hasError = (controlName: string, errorName: string) => {
        return this.resetPasswordForm.get(controlName).hasError(errorName);
    };

    public resetPassword = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.resetPasswordForm)) {
            const resetPass = this.resetPasswordForm.getRawValue();
            const resetPassModel: ResetPasswordModel = {
                password: resetPass.password,
                confirmPassword: resetPass.confirmPassword,
                token: this.token,
                email: this.email,
            };

            return this.handleSpinner(
                firstValueFrom(this.authenticationService.resetPassword(resetPassModel))
                    .then(res => {
                        this.router.navigate(['/authentication/login']);
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err, this.resetPasswordForm);
                    })
            );
        }
    };
}
